import React from "react";
import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { contactSupport } from "@src/utils/contactSupport";
import {
  priceTestConflictFaqLink,
  shippingTestConflictFaqLink,
} from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

const CART_TRANSFORM_CONFLICT_FAQ_LINK: Record<
  "Price Test" | "Shipping Test",
  string
> = {
  "Price Test": priceTestConflictFaqLink,
  "Shipping Test": shippingTestConflictFaqLink,
};

export const CartTransformConflictMessage = (
  conflictingTestLabel: "Price Test" | "Shipping Test"
) => {
  const blockedTestLabel =
    conflictingTestLabel === "Price Test" ? "Shipping Test" : "Price Test";

  return (
    <IgTypography>
      You can't have a shipping test and a price test active at the same time.
      End the active {conflictingTestLabel} to start this one, or{" "}
      <IgLink onClick={contactSupport}>contact support</IgLink> for help. See{" "}
      <IgLink
        onClick={() =>
          openNewTab(CART_TRANSFORM_CONFLICT_FAQ_LINK[blockedTestLabel], {
            mixpanelTracker: "Price and Shipping Test Conflict FAQ",
          })
        }
      >
        our docs
      </IgLink>{" "}
      for more details.
    </IgTypography>
  );
};
